module.exports = __webpack_public_path__ + "80f8df5067b58c9659bd3a0af10308e6.png";